<template lang="html">
  <div class="service">
    <bannerTop :banners="$t('gamingField.banners')" :bgPosition="bgPosition"/>
    <div class="items">
      <div class="item" v-for="(item,key) in $t('gamingField.items')" :key="key" :class="key == 1? 'write': 'item0'">
        <label class="labelTitle" :class="key == 0? 'blue': ''">{{titleToUpperCase(item.title)}}</label>
        <p class="description" v-html="item.description"></p>
      </div>
    </div>
  <cases/>
  <awards/>
  </div>
</template>

<script>
import bannerTop from '@/components/bannerTop'
import cases from '@/components/cases'
import awards from '@/components/awards'
export default {
  name: 'gamingField',
  data() {
    return {
      bgPosition: 'center right'
    }
  },
  components: {
    bannerTop,
    cases,
    awards
  },
  created() {}
}
</script>

<style lang="less" src="../../assets/css/service.less"></style>
